import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Store} from '@ngrx/store';

import {State} from '@app/app.reducers';
import {AuthenticationSuccessAction} from '@app/views/common/auth.actions';

@Injectable()
export class TokenService {

    static token: string = null;
    private loggedIn = new BehaviorSubject<boolean>(false);

    constructor(private store: Store<State>) {
        const token = this.getToken();
        this.loggedIn.next(token !== null);
    }

    public setToken(token: string, isMFAToken: boolean = false) {
        this.loggedIn.next(true);

        /* const authToken: any = {
            ...payload,
            expires: payload.expires_in + Math.floor(Date.now() / 1000)
        }*/
        localStorage.setItem('token', token);
        if (isMFAToken) {
            localStorage.setItem('MFAtoken', token);
        }
        TokenService.token = token;
    }

    public getToken(): string {
        const token = localStorage.getItem('token');
        if (TokenService.token) {
            if (token !== TokenService.token) {
                TokenService.token = token;
                const MFAToken = localStorage.getItem('MFAtoken');
                if (token && (token !== MFAToken)) {
                    this.store.dispatch(new AuthenticationSuccessAction());
                }
            }
        } else {
            TokenService.token = token;
        }
        return localStorage.getItem('token');
    }

    public removeToken() {
        this.loggedIn.next(false);
        localStorage.removeItem('token');
        localStorage.removeItem('MFAtoken');
        TokenService.token = null;
    }

    /* public tokenNotExpired() {
        return this.isAuthenticated();
    }*/

    public isAuthenticated(): boolean {
        const token = this.getToken();
        return token !== null;
    }

    get isLoggedIn() {
        return this.loggedIn.asObservable();
    }
}
